import React from 'react';
import '../styles/Loading.css';

const Loading = () => {
  return (
    <div className="loading-container">
      <img 
        src="/flairlogoonly.png" 
        alt="Loading..." 
        className="loading-logo"
      />
    </div>
  );
};

export default Loading; 